// extracted by mini-css-extract-plugin
export default {"table-container":"qvKxtUbOCPQUxMyXofDw","table-top-right-field":"lWszdEj_xeJIAUjFk3Wa","divider":"JDt0dxqTXqLkbQZa8EbR","table":"_GRLOrFNlwjooX2hEaKg"};